//@ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';
import { Problem } from '@yandex-int/k-common/typings';

import { isCodingProblem } from '../components/coding-problem/utils';
import { isRobotProblem } from '../components/robot/utils/isRobotProblem';
import { isWebProblem } from '../components/web-problem/utils';
import { isWebserviceProblem } from '../components/webservice-problem/utils';

export const getProblemPreview = (problem: Problem): string | undefined => {
    const layout = problem!.markup.layout;
    const instructionFromMarkup = problem!.markup?.preview_instruction?.text;
    const isTheory = problem.type === PROBLEM_INNER_TYPES.THEORY;

    if (isTheory) {
        const firstTextBlockFromLayout = layout?.find((item) => item.kind === 'text');

        return instructionFromMarkup ? instructionFromMarkup : firstTextBlockFromLayout?.content?.text;
    }

    if (isRobotProblem(problem)) {
        return problem.markup?.options?.instruction;
    }

    if (isWebProblem(problem) || isCodingProblem(problem) || isWebserviceProblem(problem)) {
        return problem.markup.instruction;
    }

    const instructionFromLayout = layout?.find(
        (item) => item.kind === 'text' && item.content?.options?.style === 'instruction'
    );

    return instructionFromMarkup ? instructionFromMarkup : instructionFromLayout?.content?.text;
};
